export const requestFullscreen = () => {
  const docEl = document.documentElement;
  if (!docEl) return;
  const request = docEl.requestFullscreen || docEl.webkitRequestFullscreen || docEl.msRequestFullscreen;
  if (request) {
    request.call(docEl);
  }
};

export const exitFullscreen = () => {
  const doc = document;
  const exit = doc.exitFullscreen || doc.webkitExitFullscreen || doc.msExitFullscreen;
  if (exit) {
    exit.call(doc);
  }
};
